<template>
    <div>
      <div id="fileDropZone" v-bind:class="{dropZoneAvailable: dragover}">Testing</div>

      <v-sheet
        id="fileZone"
        ref="dzone"
        tabindex="0"
        title="Click to upload"
        color="indigo lighten-4"
        width="100%"
        height="200"
        class="pa-2"
      >
      Dragover: {{ dragover }}
      <input
        accept="*/*"
        id="fileUpload"
        ref="fileInput"
        style="display: none"
        type="file"
      />
      <v-icon
        v-if="!dragover"
        color="indigo darken-2"
        size="36"
      >fa-cloud-upload</v-icon>
      <v-icon
        v-if="dragover"
        color="indigo darken-2"
        size="36"
      >fa-plus-square</v-icon>
      <span class="title indigo--text text--darken-2">Drag'n drop or click to upload file!</span>
    </v-sheet>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      dragover: false
    }
  },

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: 'fa-calendar'
    },
    required: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Array,
      default: () => {
        return [
          (v) => !!v || 'Expiration is required'
        ]
      }
    },
    value: String
  },

  mounted () {
    const dropzone = this.$el
    const fileupload = this.$el.firstElementChild

    // register listeners on your dropzone / v-sheet
    if (dropzone) {
      // register all drag & drop event listeners
      dropzone.addEventListener('dragenter', e => {
        e.preventDefault()
        this.dragover = true
      })
      dropzone.addEventListener('dragleave', e => {
        e.preventDefault()
        this.dragover = false
      })
      dropzone.addEventListener('dragover', e => {
        e.preventDefault()
        this.dragover = true
      })
      dropzone.addEventListener('drop', e => {
        e.preventDefault()
        this.dragover = false
        const dragevent = e
        if (dragevent.dataTransfer) {
          this.fileSelected(dragevent.dataTransfer.files)
        }
      })
      dropzone.addEventListener('click', e => {
        e.preventDefault()
        if (fileupload) {
          fileupload.click()
        }
      })
      dropzone.addEventListener('keypress', e => {
        e.preventDefault()
        const keyEvent = e
        if (keyEvent.key === 'Enter') {
          if (fileupload) {
            fileupload.click()
          }
        }
      })

      // register listeners on the file input
      if (fileupload) {
        fileupload.addEventListener('change', e => {
          const target = (e.target)
          if (target.files) {
            this.fileSelected(target.files)
          }
        })
      }
    }
  },

  methods: {
    fileSelected (event) {
      console.log('FileDrop.fileSelected')
      console.log(event)
      this.loading = true

      const files = event
      if (files[0] !== undefined) {
        this.file.name = files[0].name

        if (this.file.name.lastIndexOf('.') <= 0) {
          return
        }

        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.file.url = fr.result
          this.file.data = files[0]
        })
      } else {
        this.file.name = ''
        this.file.data = null
        this.file.url = ''
      }

      this.loading = false
    }
  }

}
</script>

<style>
#fileDropZone {
  box-sizing: border-box;
  display: block;
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 100000;
  background: rgba(#444, .8)
}

.dropZoneAvailable {
  display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/FileDrop.vue